export default class SearchService {
    getTermsArray(valueOnly = false) {
        const arr = [];
        if (!localStorage.terms) return arr;

        return localStorage.terms.split(',').map((item) => {
            return valueOnly ? item : {name: item};
        });
    }

    doSaveTerm(term) {
        const terms = this.getTermsArray(true);

        if (terms.includes(term.trim())) return;

        if (terms.length === 3) terms.splice(0, 1);

        terms.push(term);
        this.saveTermsArray(terms);
    }

    saveTermsArray(arr) {
        localStorage.terms = arr.join();
    }
}



// WEBPACK FOOTER //
// ./resources/site/js/providers/api/search-service.js